import React from "react";
import { ProjectState } from "../../../../shared";
import BlendControl from "./BlendControl";
import BlurControl from "./BlurControl";
import BrightnessControl from "./BrightnessControl";
import ContrastControl from "./ContrastControl";
import HueControl from "./HueControl";
import SaturationControl from "./SaturationControl";
import SliceControl from "./SliceControl";
import RotationControl from "./RotationControl";
import AnimationControl from "./AnimationControl";

type Props = {
  project: ProjectState
}

function GlobalControls({ project }: Props) {

  const objectNames = new Set<string>();
  objectNames.add("background");
  project.layers.forEach(layer => {
    layer?.detectedObjects?.forEach((d) => {
      objectNames.add(d.name);
    })
  });

  return (
    <div style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    }}>
        <div
          style={{
              color: 'white',
              backgroundColor: 'black',
              padding: 16,
              margin: 16,
          }}>
              <h1>Global</h1>
              <BrightnessControl project={project} />
              <ContrastControl project={project} />
              <HueControl project={project} />
              <SaturationControl project={project} />
              <BlurControl project={project} />
              <BlendControl project={project} />
              <SliceControl project={project} />
              <RotationControl project={project} />
              <AnimationControl project={project} />
      </div>
    </div>
  );
}

export default GlobalControls;